import { ref } from "vue";

const FEEDBACK_BUTTON_CLASS = ".tf-v1-sidetab-button";
const GIUDE_BUTTON_ID = "#zohohc-asap-web-launcherbox";

const HIDE_FEEDBACK_BUTTON_ROUTES = ["resumes.preview", "cover-letters.preview", "resumes.edit", "community"];

export const useFeedbackButtonVisible = () => {
    const isTypeFormMounted = ref(false);
    const isGiudeFormMounted = ref(false);

    const hideFeedbackButton = () => {
        document.querySelectorAll(FEEDBACK_BUTTON_CLASS).forEach((element) => {
            element.classList.add("!hidden");
        });
    };

    const showFeedbackButton = () => {
        if (!isTypeFormMounted.value) {
            initiateTypeformBtn();
            return;
        }

        document.querySelectorAll(FEEDBACK_BUTTON_CLASS).forEach((element) => {
            element.classList.remove("!hidden");
        });
    };

    const hideGuideBtn = () => {
        document.querySelectorAll(GIUDE_BUTTON_ID).forEach((element) => {
            element.classList.add("!hidden");
        });
    };

    const showGuideBtn = () => {
        if (!isGiudeFormMounted.value) {
            initiateGiudeBtn();
            return;
        }

        document.querySelectorAll(GIUDE_BUTTON_ID).forEach((element) => {
            element.classList.remove("!hidden");
        });
    };

    const isButtonHiddenForRoute = (routeName) => {
        return HIDE_FEEDBACK_BUTTON_ROUTES.includes(routeName);
    };

    const initiateTypeformBtn = () => {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "//embed.typeform.com/next/embed.js");
        document.head.appendChild(recaptchaScript);

        isTypeFormMounted.value = true;
    };

    const initiateGiudeBtn = () => {
        const script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", "https://desk.zoho.com/portal/api/web/inapp/729283000034838223?orgId=778046850");
        script.setAttribute("defer", "");

        document.head.appendChild(script);

        isGiudeFormMounted.value = true;
    };

    return {
        FEEDBACK_BUTTON_CLASS,
        HIDE_FEEDBACK_BUTTON_ROUTES,
        GIUDE_BUTTON_ID,

        hideFeedbackButton,
        showFeedbackButton,
        isButtonHiddenForRoute,

        hideGuideBtn,
        showGuideBtn,

        initiateTypeformBtn,
        initiateGiudeBtn,

        isTypeFormMounted,
        isGiudeFormMounted,
    };
};
